__turbopack_context__.v({
  "marginBottom": "gH4KNa_marginBottom",
  "text": "gH4KNa_text",
  "textCenter": "gH4KNa_textCenter",
  "textHeading": "gH4KNa_textHeading",
  "textSubeading": "gH4KNa_textSubeading",
});
